import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';
import { UntypedFormGroup, FormArray, Validators, UntypedFormBuilder, FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { Globals } from 'src/app/globals';

import { debounceTime, tap, switchMap, finalize } from 'rxjs/operators';
import { PlayerService } from '../shared/player.service';
import { PlayerViewModel } from '../shared/models/player.model';
import { Observable } from 'rxjs';
import { MatFormField } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatList, MatListItem, MatListItemTitle, MatListModule } from '@angular/material/list';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { DatePipe } from '@angular/common';
import { MatLine } from '@angular/material/core';


@Component({
    selector: 'app-player-search-dialog',
    templateUrl: './player-search-dialog.component.html',
    styleUrls: ['./player-search-dialog.component.css'],
  imports: [MatDialogTitle, ReactiveFormsModule, MatFormField, MatInput, MatListModule, CdkScrollable, MatDialogContent, MatListItem, MatListItemTitle, MatDialogActions, MatDialogClose, DatePipe, MatButtonModule]
})
export class PlayerSearchDialogComponent implements OnInit {

  playersForm: UntypedFormGroup;
  isLoading = false;
  filteredPlayers: PlayerViewModel[] = [];
  positionNames =  ['','G','D','D','F','F','F'];

  @Output() dataChanged =  new EventEmitter();

  constructor(private fb: UntypedFormBuilder,
    public dialogRef: MatDialogRef<PlayerSearchDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _playerService: PlayerService
  ) { }

 

  ngOnInit() {

    this.playersForm = this.fb.group({
      userInput: null
    })

     

  }

  addPlayer(PlayerId){
    this._playerService.AddToTeamSeason(PlayerId, this.data.TeamId, this.data.SeasonId).subscribe( res=>{
      console.log("result" + res);
      this.dataChanged.emit();
    }

    );

  }

  doFilter(filterKey) {
    //console.log(filterKey)
    if (filterKey.length > 2) {
      // your logic
      this.search();
    } else {
      this.filteredPlayers = [];
    }
  }

  search(){
    this._playerService.search(this.playersForm.get('userInput').value).subscribe((results: PlayerViewModel[])=>{
      this.filteredPlayers = results;
    });

  }

}
